import React from "react";
import useIsLoggedIn from "../utils/use-is-logged-in"
import store from "../store";
import Header from "./ey-ui-clone/Header";
import consts from "../v2/utils/consts.json";
import { useHistory } from "react-router-dom";

export default function AppBar({children}) {
  const { userInfo } = useIsLoggedIn();
  const history = useHistory();

  return (
    <>
      <Header
        title='Smart Contract & Token Review'
        accountName={userInfo?.auth0Subscripton ? ' (' + userInfo.accountName + ')' : ''}
        user={{ given_name: userInfo?.name || '', email: userInfo?.email || '', picture: userInfo?.picture || '' }}
        handleSignIn={() => { window.open(window['config'].AUTH_UI, '_top') }}
        handleSignOut={() => { store.logout() }}
        handleMyReviewsClick={() => history.push(consts.ROUTES.MYREVIEWS)}
        additionalUserProfileMenuItems={[]}
      >
        {children}
      </Header>
    </>
  )
}